module.exports = __webpack_public_path__ + "img/code.e48a991c.png";